import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: '@dogmom_atlanta',
  avatar: 'https://i.pravatar.cc/80?img=1',
  review: 'OMG, just tried the Key Ritual trick from the protocol this morning. Normally Bailey starts pacing and whining the second I touch my bag, but he actually stayed on his bed. I almost cried. Thank you! 🙏'
}, {
  name: '@sarah_and_bailey',
  avatar: 'https://i.pravatar.cc/80?img=5',
  review: "I've spent hundreds on trainers and nothing worked. I was skeptical about a 15-minute fix but Day 3 and the progress is insane. He's actually calm when I come back home. Best $37 I've spent."
}, {
  name: '@mike_rescuedad',
  avatar: 'https://i.pravatar.cc/80?img=12',
  review: "Adopted a 4-year-old pit mix with severe anxiety. Two trainers gave up on him. This bundle — especially the Rescue Dog Integration Guide — was a game changer. He's a completely different dog now. Worth 100x the price."
}];
function StarRating() {
  return <div className="flex gap-0.5 mb-3" data-id="element-218">
      {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-orange-400 text-orange-400" data-id="element-219" />)}
    </div>;
}
export function SocialProofSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section ref={ref} className="bg-[#1A1A1A] py-16 px-4" data-id="element-220">
      <div className="max-w-6xl mx-auto" data-id="element-221">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5
      }} className="text-center mb-12" data-id="element-222">
          <p className="text-orange-400 font-semibold text-sm uppercase tracking-widest mb-2" data-id="element-223">
            Real Results
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-224">
            What Dog Owners Are Saying
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-225">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="bg-[#242424] border border-[#333] rounded-xl p-6 flex flex-col" data-id="element-226">
              <div className="flex items-center gap-3 mb-4" data-id="element-227">
                <img src={t.avatar} alt={t.name} className="w-11 h-11 rounded-full border-2 border-orange-400/50 object-cover" data-id="element-228" />
                <div data-id="element-229">
                  <p className="text-white font-semibold text-sm" data-id="element-230">{t.name}</p>
                  <p className="text-slate-500 text-xs" data-id="element-231">Verified Buyer</p>
                </div>
              </div>

              <StarRating data-id="element-232" />

              <div className="relative bg-[#1A1A1A] rounded-lg p-4 flex-1" data-id="element-233">
                <p className="text-slate-300 text-sm leading-relaxed" data-id="element-234">
                  "{t.review}"
                </p>
                <div className="absolute -top-2 left-5 w-4 h-4 bg-[#1A1A1A] rotate-45" data-id="element-235" />
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="mt-14 pt-8 border-t border-[#2a2a2a] text-center" data-id="element-236">
          <p className="text-slate-500 text-xs uppercase tracking-widest mb-4" data-id="element-237">
            Consistent with techniques recommended by
          </p>
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-slate-300" data-id="element-238">
            <span className="font-semibold text-base" data-id="element-239">
              American Kennel Club Experts
            </span>
            <span className="text-orange-400/60 hidden sm:inline" data-id="element-240">|</span>
            <span className="font-semibold text-base" data-id="element-241">
              Certified Behaviorists
            </span>
            <span className="text-orange-400/60 hidden sm:inline" data-id="element-242">|</span>
            <span className="font-semibold text-base" data-id="element-243">
              Leading Canine Journals
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}